import { z } from "zod"
const status = z.object({ hasKey: z.boolean(), voices: z.array(z.string().min(1)) })
const answer = z.object({ sessionId: z.string().min(1), sdp: z.string().min(1) })
export function hasVoiceBridge(): boolean {
    return typeof window !== "undefined" && typeof window.wildlarkAPI?.voice?.create === "function"
}
function bridge() {
    const api = window.wildlarkAPI?.voice
    if (!api) throw new Error("Conversation mode requires the updated WildLark desktop app")
    return api
}
export const voiceAPI = {
    status: async () => status.parse(await bridge().status()),
    setKey: (key: string) => bridge().setKey(key),
    removeKey: () => bridge().removeKey(),
    prepare: () => bridge().prepare(),
    create: async (input: { sdp: string; voice: string }) => answer.parse(await bridge().create(input)),
    release: () => bridge().release(),
}
